import './App.css';
import Main from "./components/Main";

function App() {
  return (
    <div className="App masters-bg">
        <Main/>
    </div>
  );
}

export default App;
